import { Component, EventEmitter, Output } from '@angular/core';
import { lastValueFrom, Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Store } from '@ngrx/store';
import { emptyCart, setCart, setStepperStep } from '../calculation/calculation.actions';
import { AppState } from '../app.state';
import { calculationTypes, noModelCalculationTypes } from '../calculation/calculation.constants';
import { map } from 'rxjs/operators';
import { selectCalculations } from '../calculation/calculation.state';
import { ShoppingCartDto } from '../../api/models/shopping-cart-dto';
import { CartService } from '../../api/services/cart.service';
import { SessionService } from '../auth/session.service';
import { CoreComponent } from '../core.component';
import { UserDto } from '../../api/models/user-dto';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent extends CoreComponent {
  resetStep = false;
  showSidenav = false;
  calculationTypes: any = [...calculationTypes, ...noModelCalculationTypes];
  @Output() menuClick: EventEmitter<any> = new EventEmitter();
  private storeSubscription!: Subscription;
  cart: ShoppingCartDto | undefined;
  user: UserDto | null = null;

  constructor(
    private readonly authService: AuthService,
    private readonly store: Store<AppState>,
    private readonly sessionService: SessionService,
    private readonly cartService: CartService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.garbageCollector.push(
      this.store.pipe(map((state) => selectCalculations(state))).subscribe((calculationState) => {
        const cartId = this.sessionService.getCartId();
        if (!calculationState.cart && cartId) {
          this.getCart(cartId);
        }
        this.cart = calculationState.cart;
      }),
    );
    this.garbageCollector.push(
      this.authService.currentUser.subscribe((user) => {
        if (!this.user && user) {
          this.sessionService.removeCart();
        } else if (this.user && !user) {
          const cartId = this.sessionService.getCartId();
          if (cartId) {
            this.getCart(cartId);
          } else {
            this.sessionService.removeCart();
          }
        }
        this.user = user;
      }),
    );
    this.garbageCollector.push(
      this.sessionService.cartIdSubject.subscribe((cartId) => {
        if (!cartId) {
          this.store.dispatch(emptyCart());
        } else if (cartId !== this.cart?.id) {
          this.getCart(cartId);
        }
      }),
    );
  }

  async getCart(cartId: string) {
    try {
      const cart = await lastValueFrom(this.cartService.shoppingCartControllerGetCart({ id: cartId }));
      if (cart.id !== cartId) {
        this.sessionService.setCartId(cart.id);
      }
      this.store.dispatch(setCart({ cart }));
    } catch (e) {
      this.sessionService.removeCart();
      console.error(e);
    }
  }
  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
  }

  logout() {
    this.authService.logout();
  }

  handleResetStep() {
    this.resetStep = !this.resetStep;
    this.store.dispatch(setStepperStep({ stepperStep: 1 }));
  }

  onMenuClick() {
    this.showSidenav = true;
    this.menuClick.emit(this.showSidenav);
    this.showSidenav = false;
  }
}
